import React, {useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal as ModalAntd, Select} from "antd";
import { Modal } from "@ts-digital/vrc";
import "./reasonsModal.css";
import { clearAccountingLines, getReasons } from "../../../store/actions/precog";

const Option = Select.Option;

const ReasonsModal = ({reasonsActive, setReason}) => {
  const [tempReason, setTempReason] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const reasons = useSelector(state => state.precog.reasons);

  useEffect(() => {    
    dispatch(getReasons());    
    // pulisco altrimenti mi ritrovo le righe del dettaglio precedentemente visualizzato
    dispatch(clearAccountingLines());
  }, []);

  return (
    <ModalAntd
      mask={false}
      centered
      visible={true}
      width={"100%"}
      height={"100vh"}
      footer={false}
      wrapClassName={"purposeModal"}
      style={{padding: 0, position: "absolute", top: "0", left: 0, maxWidth:"100%", zIndex: "9999999"}}
      bodyStyle={{padding: 0}}
      closable={false}
    >
      <div>
        <header>
          <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", height: "100%", padding: "16px 0"}}>
            <div>
              <FontAwesomeIcon
                onClick={() => navigate("/precog")}
                style={{ cursor: "pointer", color: "#0090d1", margin: "0 10px 0 20px", fontWeight: "bold", fontSize: 16}}
                icon={["fal", "arrow-left"]}
              /></div>
            <div className="purposeModalTitle">
              <FormattedMessage id="preCog.modalNew.title"/>
            </div>
            <div>
           
            </div>
          </div>
        </header>
        <div className="purposeDoubleBg">
          <Modal title={"Seleziona la causale"}
            className={"selectModal"}
            visible={true}
            closable={false}
            type="primary"
            footer={false} >
            <div className="purposeDescriptionModal">
              <FormattedMessage id="preCog.modalNew.description1" />
              <br />
              <FormattedMessage id="preCog.modalNew.description2" />

            </div>
            <div style={{color: "#152935", fontWeight: "500", marginBottom: "11px"}}>
              <FormattedMessage id="preCog.modalNew.selectReason" />
            </div>
            <div style={{display: "flex"}}>              
              <Select
                onSelect={(e) => setTempReason(e)}
                suffixIcon={null}
                className="accountingResonsSelect"
                getPopupContainer={trigger => trigger.parentNode.parentNode.parentNode}
                style={{ width: "300px", marginBottom: "24px" }}
                placement="bottomLeft"
                showSearch
                placeholder={<FormattedMessage id="preCog.modalNew.selectReason" />}
                optionFilterProp="children"
                filterOption={(input, option) => {                  
                  return option.value.toLowerCase().indexOf(input.toLowerCase()) >=0 || option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                }
                }
              >
                {reasons?.data && reasons?.data?.map(el =>{
                  if (reasonsActive.includes(el.code)){
                    return  <Option key={el.code} value={el.code}>{el.description}</Option>;
                  }
                  return null;
                })}
              </Select>              
              <div className="suffixArrow" onClick={() => setReason(tempReason)}>
                <FontAwesomeIcon
                  style={{ cursor: "pointer", color: "#FFF", fontSize: 16}}
                  icon={["fal", "arrow-right"]}
                />
              </div>
            </div>
          </Modal>
        </div>
      </div>
    </ModalAntd>
  );
};

export default ReasonsModal;
